import axios from "axios";
import { get, isEmpty } from "lodash";

const ERROR_STATUSES = [
  "UNSUPPORTED_REGION",
  "TOKEN_ERROR",
  "API_ERROR",
  "EMPTY_ESTIMATE",
  "PARSE_ERROR",
];

export default {
  methods: {
    /**
     * Fetches delivery estimates for a list of items and sets `estimated_delivery` on each.
     *
     * @param {Object} options
     * @param {string} options.country - Country code
     * @param {string} options.postalCode - Postal/zip code
     * @param {Array}  options.items - All items to fetch estimates for
     * @param {Array}  [options.priorityItems] - Optional items to fetch first (e.g. first visible items)
     */
    fetchDeliveryEstimates({ country, postalCode, items, priorityItems }) {
      if (!postalCode || !country) return;

      const params = { country, postal_code: postalCode };

      const applyEstimates = (targetItems, estimates) => {
        targetItems.forEach((item) => {
          const estimate = estimates[item.sku];
          if (estimate && !ERROR_STATUSES.includes(estimate)) {
            this.$set(item, "estimated_delivery", estimate);
          }
        });
      };

      // Deduplicate and collect priority SKUs
      const prioritySeen = new Set();
      const validPriority = (priorityItems || []).filter((item) => {
        if (!item.sku || item.out_of_stock || prioritySeen.has(item.sku))
          return false;
        prioritySeen.add(item.sku);
        return true;
      });

      // Fetch priority items first if provided
      if (validPriority.length) {
        const prioritySkus = validPriority.map((item) => item.sku);
        axios
          .get("/v2/customer_requests/delivery_estimates", {
            params: { ...params, skus: prioritySkus },
          })
          .then((response) => {
            applyEstimates(
              items.filter((item) => prioritySeen.has(item.sku)),
              get(response, "data.delivery_estimates", {})
            );
          })
          .catch(() => {});
      }

      // Fetch remaining items (deduplicated, excluding priority and out-of-stock)
      const remaining = items.filter((item) => {
        if (!item.sku || item.out_of_stock || prioritySeen.has(item.sku))
          return false;
        prioritySeen.add(item.sku);
        return true;
      });
      if (!remaining.length) return;

      const skus = remaining.map((item) => item.sku);
      axios
        .get("/v2/customer_requests/delivery_estimates", {
          params: { ...params, skus },
        })
        .then((response) => {
          applyEstimates(
            remaining,
            get(response, "data.delivery_estimates", {})
          );
        })
        .catch(() => {});
    },
  },
};
